import moment from 'moment';
import { useContext } from 'react';
import { GetEventSessionAttendeesQuery } from '../../../API';
import UserContext from '../../../contexts/UserContext';
import useGetUserEventSessions from '../../../hooks/useGetUserEventSessions';
const Home = () => {
  const { currentUser } = useContext(UserContext);
  const { data: userEventSessions } = useGetUserEventSessions(currentUser?.username);
  return (
    <div>
      <div className=" bg-periwinkle-200 p-5">
        <a
          href="https://www.weflourish.com/download-flourish?_branch_match_id=1084298723723119467&utm_source=website&utm_campaign=website_lead&utm_medium=organic&_branch_referrer=H4sIAAAAAAAAA8soKSkottLXL09Ny8kvLcosztBLLCjQy8nMy9ZPyS%2FPy8lPTAEAExMBGCQAAAA%3D"
          target="_blank"
          rel="noreferrer">
          Click here to download the Flourish mobile app!
        </a>
      </div>
      <div className="p-10">
        {/* <h1 className="font-analogue font-bold text-xl">Welcome, {user?.firstName}!</h1> */}
        <div className="pt-6 px-4 mt-4">
          <h1 className="font-extrabold text-2xl mb-5">Upcoming small group sessions</h1>
          {renderEventSessionsGrid(userEventSessions)}
        </div>
      </div>
    </div>
  );
};

export default Home;

function renderEventSessionsGrid(sessions: []) {
  return (
    <div className="w-full grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 gap-y-5 overflow-x-auto">
      {sessions &&
        sessions.length > 0 &&
        sessions.map((item, k) => (
          <div className="bg-white rounded-lg p-4 relative" key={k}>
            <div className="relative overflow-clip flex items-center justify-center">
              <img
                src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1637164857318x165310455736167330%2Fpexels-cup-of-couple-resisting%2520the%2520reset.jpeg?w=384&h=192&auto=compress&dpr=1&fit=crop&q=100"
                className="rounded-lg w-full"
                alt=""
              />
              <div className="px-5 bg-periwinkle text-white rounded-xl absolute top-2 right-2 text-center">Small Group</div>
            </div>
            <div className="flex gap-2 items-center mt-3">
              <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M16 8C16 3.58282 12.4172 0 8 0C3.58282 0 0 3.58282 0 8C0 12.4172 3.58282 16 8 16C12.4172 16 16 12.4172 16 8Z" fill="#2D8CFF" />
                  <path
                    d="M3.33801 5.33203H8.65926C8.65926 5.33203 9.95634 5.46428 10.0007 6.53054V10.6592H4.84859C4.84859 10.6592 3.37829 10.8369 3.33398 9.28299V5.33203H3.33801Z"
                    fill="white"
                  />
                  <path d="M12.6667 5.33203V10.6654L10 9.10671V6.9279L12.6667 5.33203Z" fill="white" />
                </svg>
              </div>

              <span className="uppercase font-roboto-mono text-sm">
                Starts {moment((item as GetEventSessionAttendeesQuery['getEventSessionAttendees'])?.eventSession?.startDate).format('MMM DD')}
              </span>
            </div>
            <div>
              <p className="text-lg mt-3 font-light">{(item as GetEventSessionAttendeesQuery['getEventSessionAttendees'])?.eventSession?.sessionTitle}</p>
              <p className="font-bold">{`${moment((item as GetEventSessionAttendeesQuery['getEventSessionAttendees'])?.eventSession?.startDate).format(
                'dddd'
              )}s at ${moment((item as GetEventSessionAttendeesQuery['getEventSessionAttendees'])?.eventSession?.startDate).format('h:mm a')}`}</p>
            </div>
          </div>
        ))}
      {sessions && sessions.length < 1 && <div>No upcoming small group sessions</div>}
    </div>
  );
}
